import React, { useRef } from 'react'
import LeaveForm from '../components/form_accept'

type Props = {}

const LeaveFormPublic = (props: Props) => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    return (

        <main id="pdf-export-container" className=" w-[8.27in] h-[10.99in] relative mt-[1px] text-[12px] py-7 px-4 bg-white m-auto" ref={contentRef}>
            <LeaveForm

            />
        </main>
    )
}

export default LeaveFormPublic